module.exports = __webpack_public_path__ + "static/media/scss.50b85345.png";